import { SweetenerKeys } from "~/types/products";

/** Map key on `Product.sweeteners` for FRAPI COUPON (Samsung) — keep in sync with fuel-OL `generateKey("COUPON")`. */
export const SAMSUNG_BEST_BUY_COUPON_SWEETENER_KEY = SweetenerKeys.SAMSUNG_BEST_BUY_COUPON;
